var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlurBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 990,
  height: 743,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blur-bg_svg__a)",
  opacity: 0.56
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C830E1",
  d: "M680.186 350.1c-2.494-2.221-5.3-4.566-8.729-6.91-19.171-13.512-53.928-22.643-90.557-28.258-36.628-5.614-75.594-8.144-113.624-11.722-16.21-1.543-32.576-3.27-49.253-3.208-34.914.123-67.645 8.329-87.752 19.619-20.106 11.291-28.679 25.296-30.081 39.117-1.247 12.401 3.429 25.357 20.885 35.599 9.352 5.491 21.977 9.933 34.602 14.375 19.483 6.849 38.966 13.759 58.449 20.607 10.443 3.702 21.198 7.466 33.823 9.995 41.304 8.268 103.961 1.604 136.381-9.871 7.793-2.777 16.053-5.245 24.47-7.712 16.054-4.689 32.576-9.378 45.512-15.548 10.911-5.244 19.328-11.229 25.25-17.646 13.093-14.622 14.496-25.604.624-38.437"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "blur-bg_svg__a",
  width: 990,
  height: 743,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 50
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_21121_58317"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_21121_58317",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect2_foregroundBlur_21121_58317",
  stdDeviation: 150
})))));
export { SvgBlurBg as ReactComponent };
export default __webpack_public_path__ + "static/media/blur-bg.28fe7d4c.svg";